<template>
  <div class="app">
    <keep-alive :include="['chat','location-picker']">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState({
		    pageVisibleOrHidden:state => state.user.pageVisibleOrHidden,
		})
	},
	created(){
		let that = this
		document.addEventListener("visibilitychange", function() {
				that.$store.commit('setPageVisibleOrHidden',document.visibilityState)
		});
	},
    mounted(){
      if(window.location.pathname.indexOf('chat')!=-1){
          if(/Windows|Macintosh/i.test(navigator.userAgent)) {
            this.$router.push({name:'pchat',query:JSON.parse(sessionStorage.getItem('query'))})
          } else {
            this.$router.push({name:'mchat',query:JSON.parse(sessionStorage.getItem('query'))})
          }
      }
    }
}
</script>
<style>
    body,html{
        height: -webkit-fill-available;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
    .messageTips{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .btnMessage{
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        text-align: center;
        box-sizing: border-box;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 20px;
        color: #fff;
        background-color: #666666;
    }
</style>